import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import DXB from './Pages/DXB';
import AUH from './Pages/AUH';
import RAK from './Pages/RAK';
import Birthday from './Pages/Birthday';
import BankeBirthday from './Pages/BankeBirthday';
import BankeCapital from './Pages/BankeCapital';
import Event from './Pages/Event';
import Office313 from './Pages/313Office';
import Office413 from './Pages/413Office';
import Award from './Pages/Award';
import { hasBirthdayToday } from './Pages/birthdayConfig';

function App() {
  const defaultPath = hasBirthdayToday() ? '/birthday' : '/dxb';

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={defaultPath} replace />} />
        <Route path="/dxb" element={<DXB />} />
        <Route path="/auh" element={<AUH />} />
        <Route path="/rak" element={<RAK />} />
        <Route path="/birthday" element={<Birthday />} />
        <Route path="/bankebirthday" element={<BankeBirthday />} />
        <Route path="/bankecapital" element={<BankeCapital />} />
        <Route path="/event" element={<Event />} />
        <Route path="/313office" element={<Office313 />} />
        <Route path="/413office" element={<Office413 />} />
        <Route path="/award" element={<Award />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
